import { render, staticRenderFns } from "./relevance-form.vue?vue&type=template&id=32d58345&scoped=true&"
import script from "./relevance-form.vue?vue&type=script&lang=ts&"
export * from "./relevance-form.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form.vue?vue&type=style&index=0&id=32d58345&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d58345",
  null
  
)

export default component.exports